<template>
  <div style="text-align: center">
    <div class="tittle-success">
      <i class="el-icon-success"></i>
      <span>支付成功 感谢您的支持</span>
    </div>
    <table class="entrust-table">
      <tr>
        <th>委托单号：</th>
        <td>{{testEntrust.orderNo}}</td>
      </tr>
      <tr>
        <th>检验费用：</th>
        <td>{{testEntrust.sumPrice - testEntrust.discountPrice}} 元</td>
      </tr>
    </table>
    <el-card shadow="never" style="width: 460px;margin: 20px auto">
      <div style="color: #E6A23C;text-align: left;margin-left: 30px;margin-top:10px;margin-bottom: 10px">
        <i class="el-icon-warning"></i>
        <span style="margin-left: 5px;">请按下方地址信息寄送检验样品!</span>
        <div tyle="margin-left: 5px;">并在个人中心-委托管理-我的委托-待检验，点击【发送样品】填写快递信息</div>
      </div>
      <table class="entrust-table" width="100%">
        <tr>
          <th width="30%">单位名称：</th>
          <td>{{testInspectionOrgEdit.name}}</td>
        </tr>
        <tr>
          <th>地  址：</th>
          <td>{{testInspectionOrgEdit.address}}</td>
        </tr>
        <tr>
          <th>收样人：</th>
          <td>{{testInspectionOrgEdit.sampleCollectionPerson}}</td>
        </tr>
        <tr>
          <th>收样手机：</th>
          <td>{{testInspectionOrgEdit.sampleCollectionPhone}}</td>
        </tr>
        <tr>
          <th>邮  编：</th>
          <td>{{testInspectionOrgEdit.postcode}}</td>
        </tr>
        <tr>
          <th>电  话：</th>
          <td>{{testInspectionOrgEdit.phone}}</td>
        </tr>
        <tr>
          <th>邮  箱：</th>
          <td>{{testInspectionOrgEdit.email}}</td>
        </tr>
        <tr>
          <th>网  址：</th>
          <td>{{testInspectionOrgEdit.website}}</td>
        </tr>
      </table>
    </el-card>
    <el-divider></el-divider>
    <div class="clearfix" style="text-align: center">
      <el-button size="medium" type="info" @click="reLoad()">申请新的委托</el-button>
      <el-button size="medium" type="primary" @click="toPage('myEntrust')">进入委托管理</el-button>
    </div>
  </div>
</template>

<script>
import { getTestEntrustResponse } from '@/api/test/entrust'
export default {
  name: 'submit-success',
  props: {
    entrustId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      testInspectionOrgEdit: {},
      testEntrust: {}
    }
  },
  mounted () {
    this.getTestEntrustResponse()
  },
  methods: {
    toPage (path) {
      this.$router.push({
        name: path
      })
    },
    reLoad () {
      this.$router.go(0)
    },
    getTestEntrustResponse () {
      let param = { entrustId: this.entrustId }
      getTestEntrustResponse(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData.testInspectionOrgEdit) {
            this.testInspectionOrgEdit = result.bizData.testInspectionOrgEdit
          }
          if (result.bizData.testEntrust) {
            this.testEntrust = result.bizData.testEntrust
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .tittle-success {
    text-align: center;
    i {
      font-size: 64px;
      color: #32A08C;
      vertical-align: middle;
    }
    span {
      font-size: 32px;
      color: #303133;
      margin-left: 10px;
      margin-top: 15px;
    }
  }

  .entrust-table {
    margin: auto;
    th{
      text-align: right;
      font-weight: 400;
    }
    td{
      text-align: left;
      text-space: 2px;
    }
  }
</style>
